import { Http } from '@services/http/http.service';

const path = '/workspace';

/** One identity of the caller's workspace, as returned by `GET /api/v1/workspace/identities`. */
export type WorkspaceIdentity = {
  id: string;
  name: string;
  /** FHIR resource type — `Organization`, `PractitionerRole`, `Practitioner` or `Device`. */
  type: string;
};

/**
 * Every medical-visa identity in the caller's workspace, not just the ones the
 * user holds themselves. The feature-set filtering is done server-side.
 */
export async function getWorkspaceIdentities(): Promise<WorkspaceIdentity[]> {
  return await Http.getInstance().get({ path: `${path}/identities` });
}
